/* ==========================================================================
   firefly-mega-nav.js
   Firefly 自定义 header 的移动抽屉交互
   复刻 done 主题移动抽屉的核心行为：
   - 点汉堡按钮：滑入抽屉（body 加 firefly-mega-nav-open）
   - 点一级带子菜单的项：展开二级面板（.navigation__item--open + drawer--child-open）
   - 点返回 / 关闭 / 遮罩：收起
   桌面下拉仍由纯 CSS :hover 处理，本脚本只管移动抽屉。
   ========================================================================== */
(function () {
  'use strict';

  var BODY_OPEN_CLASS = 'firefly-mega-nav-open';
  var DRAWER_CHILD_OPEN_CLASS = 'firefly-mobile-drawer--child-open';
  var ITEM_OPEN_CLASS = 'navigation__item--open';
  var TAP_CLOSED_CLASS = 'firefly-mega-nav__item--tap-closed';
  var TAP_STORAGE_KEY = 'firefly-mega-nav:tapped-at';
  var activeTapRelease = null;
  var MOBILE_SEARCH_OPEN_CLASS = 'is-search-open';
  var MOBILE_SEARCH_ONLY_CLASS = 'firefly-mobile-drawer--search-only';

  /* 指针是否仍停留在任一菜单触发器或“真正展开中”的面板范围内。
     两个关键排除，否则指针在页面任意位置都被判成“还在菜单上”、
     点击抑制永不解除，表现为菜单点击后 hover 不开、要点一下才有反应：
     - 被抑制（tap-closed）的面板已收起：clip-path/visibility 只是视觉隐藏，
       DOM 矩形仍罩着视口大片区域，不能计入；
     - 面板是纯 CSS :hover 展开的，仅当该 item 的 hover 链仍活跃时其矩形才有效；
       收起的面板不参与命中测试（clip-path 裁剪区 / visibility:hidden），此时
       鼠标即使悬在其矩形内也不会令 item:hover 成立，matches(':hover') 即可区分。 */
  function isPointerOverMegaNav(clientX, clientY) {
    var items = document.querySelectorAll('.firefly-nav .navigation__item--with-children');
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var rect = item.getBoundingClientRect();
      if (
        clientX >= rect.left && clientX <= rect.right &&
        clientY >= rect.top && clientY <= rect.bottom
      ) return true;

      if (item.classList.contains(TAP_CLOSED_CLASS)) continue;
      if (!item.matches(':hover')) continue;

      for (var c = 0; c < item.children.length; c++) {
        if (!item.children[c].classList.contains('navigation__tier-2-container')) continue;
        var panelRect = item.children[c].getBoundingClientRect();
        if (
          clientX >= panelRect.left && clientX <= panelRect.right &&
          clientY >= panelRect.top && clientY <= panelRect.bottom
        ) return true;
      }
    }
    return false;
  }

  function releaseTapClosed() {
    var closed = document.querySelectorAll('.' + TAP_CLOSED_CLASS);
    for (var i = 0; i < closed.length; i++) {
      closed[i].classList.remove(TAP_CLOSED_CLASS);
    }
    try { window.sessionStorage.removeItem(TAP_STORAGE_KEY); } catch (error) { /* 隐私模式等场景忽略 */ }
    if (activeTapRelease) {
      document.removeEventListener('mousemove', activeTapRelease, true);
      activeTapRelease = null;
    }
  }

  /* 挂“真实移动”监听。origin 为空时（整页跳转后的新文档没有点击坐标），
     以第一帧 mousemove 作为基准。解除必须同时满足：
     1. 距基准 400ms 以上——盖住点击瞬间的手部微动与滚动动画派发的合成 mousemove；
     2. 距基准坐标位移 24px 以上——合成 mousemove 坐标不变，微动远小于该值；
     3. 指针已离开整个菜单区（含面板）——鼠标还悬在菜单上时解除，
        :hover 会立即把面板重新展开，正是“收回后又弹开”的来源。 */
  function armTapRelease(origin) {
    if (activeTapRelease) {
      document.removeEventListener('mousemove', activeTapRelease, true);
    }
    var pending = origin || null;
    activeTapRelease = function (moveEvt) {
      if (!pending) {
        pending = { x: moveEvt.clientX, y: moveEvt.clientY, at: Date.now() };
        return;
      }
      if (Date.now() - pending.at < 400) return;
      if (
        Math.abs(moveEvt.clientX - pending.x) < 24 &&
        Math.abs(moveEvt.clientY - pending.y) < 24
      ) return;
      if (isPointerOverMegaNav(moveEvt.clientX, moveEvt.clientY)) return;
      releaseTapClosed();
    };
    document.addEventListener('mousemove', activeTapRelease, true);
  }

  /* 整页跳转场景：点击菜单链接跳到新页面后，tap-closed 类随旧文档销毁，
     指针仍悬在菜单上会让新页面一加载就把面板 hover 展开。
     通过 sessionStorage 把“刚点击过菜单”带到新文档：5 秒内先全部抑制，
     等鼠标真实移动且离开菜单区后再恢复常规 hover（见 armTapRelease）。 */
  function initDesktopTapSuppression() {
    var tappedAt = 0;
    try {
      tappedAt = parseInt(window.sessionStorage.getItem(TAP_STORAGE_KEY), 10) || 0;
    } catch (error) { /* 读取失败视为没有标记 */ }

    if (!tappedAt || Date.now() - tappedAt >= 5000) return;

    var items = document.querySelectorAll('.firefly-nav .navigation__item--with-children');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.add(TAP_CLOSED_CLASS);
    }
    armTapRelease(null);
  }

  function init(root) {
    if (!root || root.__fireflyNavInit) return;
    root.__fireflyNavInit = true;

    // 滚动切换：顶部透明，滚过阈值后加 is-scrolled（白底黑字）。
    // 放在 drawer guard 之前，保证任何情况下都会绑定。
    initScrollState(root);
    initAccountDialogPosition(root);
    initSearchMegaPosition(root);
    initDesktopMegaWidth(root);
    initDesktopTapSuppression();

    var drawer = root.querySelector('#firefly-mobile-drawer');
    var backdrop = root.querySelector('.firefly-mega-nav__backdrop');
    if (!drawer) return;

    var title = drawer.querySelector('.firefly-mobile-drawer__title');
    var mobileSearch = drawer.querySelector('[data-firefly-mobile-search]');
    var mobileSearchComponent = mobileSearch ? mobileSearch.querySelector('predictive-search-component') : null;
    var mobileSearchInput = mobileSearch ? mobileSearch.querySelector('[data-firefly-mobile-search-input]') : null;
    var mobileSearchReturnFocus = null;
    var mobileSearchOpenedStandalone = false;

    function syncMobileSearchTop() {
      if (!mobileSearch) return;
      var top;

      if (mobileSearchOpenedStandalone) {
        top = Math.max(0, root.getBoundingClientRect().bottom);
      } else {
        var announcement = drawer.querySelector('.firefly-mobile-drawer__announcement');
        var header = drawer.querySelector('.firefly-mobile-drawer__header');
        top = (announcement ? announcement.offsetHeight : 0) + (header ? header.offsetHeight : 0);
      }

      mobileSearch.style.setProperty('--firefly-mobile-search-top', Math.round(top) + 'px');
    }

    function setMobileSearchTriggersExpanded(expanded) {
      root.querySelectorAll('[data-firefly-mobile-search-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function openMobileSearch(trigger) {
      if (!mobileSearch) return;
      mobileSearchReturnFocus = trigger || document.activeElement;
      mobileSearchOpenedStandalone = !document.body.classList.contains(BODY_OPEN_CLASS);

      if (mobileSearchOpenedStandalone) {
        drawer.classList.add(MOBILE_SEARCH_ONLY_CLASS);
        drawer.setAttribute('aria-hidden', 'false');
      }

      syncMobileSearchTop();
      mobileSearch.classList.add(MOBILE_SEARCH_OPEN_CLASS);
      mobileSearch.setAttribute('aria-hidden', 'false');
      setMobileSearchTriggersExpanded(true);

      window.requestAnimationFrame(function () {
        if (mobileSearchInput) mobileSearchInput.focus();
      });
      window.setTimeout(function () {
        if (mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS) && mobileSearchInput) {
          mobileSearchInput.focus();
        }
      }, 340);
    }

    function closeMobileSearch(restoreFocus) {
      if (!mobileSearch || !mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS)) return;
      mobileSearch.classList.remove(MOBILE_SEARCH_OPEN_CLASS);
      mobileSearch.setAttribute('aria-hidden', 'true');
      setMobileSearchTriggersExpanded(false);

      if (mobileSearchComponent && typeof mobileSearchComponent.resetSearch === 'function') {
        mobileSearchComponent.resetSearch(false);
      }

      if (mobileSearchOpenedStandalone) {
        drawer.classList.remove(MOBILE_SEARCH_ONLY_CLASS);
        drawer.setAttribute('aria-hidden', 'true');
        mobileSearchOpenedStandalone = false;
      }

      if (restoreFocus) {
        if (mobileSearchReturnFocus && mobileSearchReturnFocus.isConnected) {
          mobileSearchReturnFocus.focus();
        }
      }
      mobileSearchReturnFocus = null;
    }

    function openDrawer() {
      closeMobileSearch(false);
      document.body.classList.add(BODY_OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'false');
      syncMobileSearchTop();
      if (backdrop) backdrop.hidden = false;
      var toggle = root.querySelector('[data-firefly-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      closeMobileSearch(false);
      document.body.classList.remove(BODY_OPEN_CLASS);
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove(DRAWER_CHILD_OPEN_CLASS);
      collapseAll();
      if (backdrop) backdrop.hidden = true;
      var toggle = root.querySelector('[data-firefly-drawer-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    function collapseAll() {
      drawer.querySelectorAll('.' + ITEM_OPEN_CLASS).forEach(function (el) {
        el.classList.remove(ITEM_OPEN_CLASS);
        el.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
          a.setAttribute('aria-expanded', 'false');
        });
      });
      if (title) title.textContent = '';
    }

    /* 打开某个一级项的二级面板（手风琴原地展开） */
    function openItem(item) {
      // 关闭其它已展开的一级项
      drawer.querySelectorAll('.navigation__tier-1 > .' + ITEM_OPEN_CLASS).forEach(function (openItem) {
        if (openItem !== item) {
          openItem.classList.remove(ITEM_OPEN_CLASS);
          openItem.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
            a.setAttribute('aria-expanded', 'false');
          });
        }
      });

      item.classList.add(ITEM_OPEN_CLASS);
      item.querySelectorAll('.navigation__link[aria-controls], .navigation__children-toggle[aria-controls]').forEach(function (a) {
        a.setAttribute('aria-expanded', 'true');
      });
    }

    function backToTopLevel() {
      collapseAll();
    }

    /* 打开抽屉的汉堡按钮 */
    root.querySelectorAll('[data-firefly-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        openDrawer();
      });
    });

    /* 手机搜索保留导航抽屉，通过菜单内部遮罩显示搜索层。 */
    root.querySelectorAll('[data-firefly-mobile-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        openMobileSearch(btn);
      });
    });

    root.querySelectorAll('[data-firefly-mobile-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeMobileSearch(true);
      });
    });

    /* 关闭：X 按钮 / 遮罩 */
    root.querySelectorAll('[data-firefly-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        closeDrawer();
      });
    });

    /* 展开菜单中的账户入口也使用 Shopify 官方账户组件。
       内部账户抽屉打开后先关闭导航抽屉，避免两个全屏抽屉叠加。 */
    var drawerAccount = drawer.querySelector('[data-firefly-drawer-account]');
    if (drawerAccount) {
      drawerAccount.addEventListener('click', function () {
        closeDrawer();
      });
    }

    /* 返回：从二级面板回到一级列表 */
    root.querySelectorAll('[data-firefly-drawer-back]').forEach(function (btn) {
      btn.addEventListener('click', function (evt) {
        evt.preventDefault();
        backToTopLevel();
      });
    });

    /* 委托：点击一级带子菜单项的 链接 / 展开箭头 → 展开二级 */
    drawer.addEventListener('click', function (evt) {
      var trigger = evt.target.closest(
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__link, ' +
        '.navigation__tier-1 > .navigation__item--with-children > .navigation__children-toggle'
      );
      if (!trigger || !drawer.contains(trigger)) return;

      var item = trigger.closest('.navigation__item--with-children');
      if (!item || !item.parentElement || !item.parentElement.classList.contains('navigation__tier-1')) return;

      evt.preventDefault();

      if (item.classList.contains(ITEM_OPEN_CLASS)) {
        // 再次点击当前已展开项：收起
        item.classList.remove(ITEM_OPEN_CLASS);
        item.querySelectorAll('[aria-expanded="true"]').forEach(function (a) {
          a.setAttribute('aria-expanded', 'false');
        });
      } else {
        openItem(item);
      }
    });

    /* PC mega 面板是纯 CSS :hover 展开；点击面板内链接后（软切换或整页跳转）
       指针往往仍悬在菜单上，面板会立刻被 :hover 重新展开。
       点击时挂 tap-closed 抑制类立即收起，并把点击时间写入 sessionStorage
       供整页跳转后的新文档复用（见 initDesktopTapSuppression）；
       之后由 armTapRelease 在“鼠标真实移动且已离开整个菜单区”时解除。
       判定不能用 mouseleave：滚动/布局变化会断开 hover 链，误派发 mouseleave。 */
    document.addEventListener('click', function (evt) {
      // 点击一级菜单标题（非面板内容）：立即解除点击抑制，恢复常规 hover。
      // 这是抑制期间的明确恢复入口——鼠标点一下标题即可重新展开面板
      if (!evt.target.closest('.navigation__tier-2-container')) {
        if (evt.target.closest('.firefly-nav .navigation__item--with-children')) {
          releaseTapClosed();
        }
        return;
      }

      var link = evt.target.closest('.navigation__tier-2-container a[href]');
      if (!link) return;

      var item = link.closest('.navigation__item--with-children');
      if (!item) return;

      item.classList.add(TAP_CLOSED_CLASS);
      try {
        window.sessionStorage.setItem(TAP_STORAGE_KEY, String(Date.now()));
      } catch (error) { /* 隐私模式等场景忽略，仅影响整页跳转后的抑制 */ }
      armTapRelease({ x: evt.clientX, y: evt.clientY, at: Date.now() });
    });

    /* Esc 关闭 */
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape') return;

      if (mobileSearch && mobileSearch.classList.contains(MOBILE_SEARCH_OPEN_CLASS)) {
        closeMobileSearch(true);
        return;
      }

      if (document.body.classList.contains(BODY_OPEN_CLASS)) {
        closeDrawer();
      }
    });

    window.addEventListener('resize', syncMobileSearchTop, { passive: true });

    /* ====== 桌面 simple-dark-dropdown：列表 offset 对齐触发项 ======
       复刻 done 的 onProxyNavEnterSmallMenu 逻辑：
       offset = 触发项链接的 left - 内容盒 inner 的 left，
       写入 --simple-dark-dropdown-offset，使列表与橙竖线对齐触发项水平位置。 */
    initSimpleDarkOffsets(root);
    initDesktopNavState(root);
  }

  /* ====== 桌面巨幕菜单可用视口宽度 ======
     Horizon 桌面端真正的滚动容器是 .page-wrapper，而不是 documentElement。
     使用它的 clientWidth 才能排除自身的竖向滚动条，避免巨幕菜单产生横向溢出。 */
  function initDesktopMegaWidth(root) {
    var frame = 0;
    var layoutViewport = root.closest('.page-wrapper') || document.querySelector('.page-wrapper');

    function update() {
      frame = 0;
      var viewportWidth = layoutViewport && layoutViewport.clientWidth
        ? layoutViewport.clientWidth
        : document.documentElement.clientWidth || window.innerWidth;
      var viewportWidthValue = Math.round(viewportWidth) + 'px';
      root.style.setProperty('--firefly-layout-viewport-width', viewportWidthValue);
      document.documentElement.style.setProperty('--firefly-layout-viewport-width', viewportWidthValue);
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', scheduleUpdate, { passive: true });
    }

    if (window.ResizeObserver) {
      var viewportObserver = new ResizeObserver(scheduleUpdate);
      viewportObserver.observe(layoutViewport || document.documentElement);
    }
  }

  /* ====== PC 搜索巨幕定位 ======
     search-modal 位于 document 末尾并进入浏览器 top layer，无法自然跟随 Header。
     打开前读取 Firefly Header 的实际底边，兼容顶部公告栏、吸顶和自定义高度。 */
  function initSearchMegaPosition(root) {
    var trigger = root.querySelector('[data-firefly-search-open]');
    if (!trigger) return;
    var dialog = document.querySelector('#search-modal .search-modal__content');

    var frame = 0;

    function update() {
      frame = 0;
      var rect = root.getBoundingClientRect();
      var top = Math.max(0, Math.round(rect.bottom));
      document.documentElement.style.setProperty('--firefly-search-dialog-top', top + 'px');
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    trigger.addEventListener('click', function () {
      update();
      scheduleUpdate();
    }, { capture: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (dialog && window.MutationObserver) {
      var dialogObserver = new MutationObserver(function () {
        if (dialog.open) scheduleUpdate();
      });
      dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(root);
    }
  }

  /* ====== PC 账户弹窗跟随账户图标 ======
     Shopify 默认把 account dialog 固定在视口右侧；宽屏时 Header 内容盒已经居中，
     两者会错开。根据账户图标的实际位置计算弹窗左边距，让图标位于弹窗正上方，
     同时把弹窗限制在视口安全边距内。 */
  function initAccountDialogPosition(root) {
    var account = root.querySelector('.firefly-mega-nav__desktop shopify-account.firefly-mega-nav__account-link');
    if (!account) return;

    var DESKTOP_BREAKPOINT = 990;
    var DIALOG_WIDTH = 360;
    var VIEWPORT_GUTTER = 30;
    var frame = 0;

    function update() {
      frame = 0;

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        account.style.removeProperty('--firefly-account-dialog-inline-start');
        return;
      }

      var rect = account.getBoundingClientRect();
      var preferredLeft = rect.left + (rect.width / 2) - (DIALOG_WIDTH / 2);
      var maximumLeft = Math.max(VIEWPORT_GUTTER, window.innerWidth - DIALOG_WIDTH - VIEWPORT_GUTTER);
      var dialogLeft = Math.min(Math.max(VIEWPORT_GUTTER, preferredLeft), maximumLeft);

      account.style.setProperty('--firefly-account-dialog-inline-start', Math.round(dialogLeft) + 'px');
    }

    function scheduleUpdate() {
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    }

    update();
    account.addEventListener('click', update, { capture: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('pageshow', scheduleUpdate);

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleUpdate);
      resizeObserver.observe(root);
      resizeObserver.observe(account);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(scheduleUpdate);
    }
  }

  /* ====== 桌面导航稳定状态 ======
     对齐 Done 的 section-header--nav-hover / section-header--nav-open：
     菜单之间移动时保留 Header 白底和当前面板，避免 :hover 瞬间断开造成闪烁。 */
  function initDesktopNavState(root) {
    var nav = root.querySelector('.firefly-mega-nav__nav');
    if (!nav) return;

    var actions = root.querySelector('.firefly-mega-nav__desktop .firefly-mega-nav__actions');
    var closeTimer;
    var closeDelay = 140;
    var items = Array.from(nav.querySelectorAll('.navigation__tier-1 > .navigation__item'));

    function setExpanded(item, expanded) {
      item.classList.toggle('navigation__item--show-children', expanded);
      item.querySelectorAll(':scope > [aria-expanded]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    function closePanels(keepNavHover) {
      window.clearTimeout(closeTimer);
      items.forEach(function (item) {
        setExpanded(item, false);
      });
      root.classList.remove('is-menu-open');
      if (!keepNavHover) root.classList.remove('is-nav-hover');
    }

    function activate(item) {
      window.clearTimeout(closeTimer);
      root.classList.add('is-nav-hover');

      if (!item.classList.contains('navigation__item--with-children')) {
        closePanels(true);
        return;
      }

      items.forEach(function (candidate) {
        setExpanded(candidate, candidate === item);
      });
      root.classList.add('is-menu-open');
    }

    function scheduleClose() {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () {
        if (
          nav.matches(':hover') ||
          nav.contains(document.activeElement) ||
          (actions && (actions.matches(':hover') || actions.contains(document.activeElement)))
        ) return;
        closePanels(false);
      }, closeDelay);
    }

    nav.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
      root.classList.add('is-nav-hover');
    });
    nav.addEventListener('mouseleave', scheduleClose);

    /* 右侧账户 / 搜索 / 购物车与菜单共享 Header hover 状态。
       从菜单移向图标时收起下拉，但保持透明 Header 的白底黑字。 */
    if (actions) {
      actions.addEventListener('mouseenter', function () {
        closePanels(true);
        root.classList.add('is-nav-hover');
      });
      actions.addEventListener('mouseleave', scheduleClose);
      actions.addEventListener('focusin', function () {
        closePanels(true);
        root.classList.add('is-nav-hover');
      });
      actions.addEventListener('focusout', scheduleClose);
    }

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item);
      });
      item.addEventListener('focusin', function () {
        activate(item);
      });
      item.addEventListener('focusout', scheduleClose);
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-nav-hover')) {
        closePanels(false);
      }
    });

    var searchTrigger = root.querySelector('[data-firefly-search-open]');
    if (searchTrigger) {
      searchTrigger.addEventListener('click', function () {
        closePanels(false);
      });
    }
  }

  function initSimpleDarkOffsets(root) {
    var nav = root.querySelector('.firefly-mega-nav__nav');
    if (!nav) return;

    var items = nav.querySelectorAll('.navigation__item--simple-dark-dropdown');

    function updateOffset(item) {
      var dropdown = item.querySelector(':scope > .navigation__tier-2-container');
      if (!dropdown) return;
      var inner = dropdown.querySelector('.simple-dark-dropdown__inner');
      var link = item.querySelector(':scope > .navigation__link');
      if (!inner || !link) return;
      var innerLeft = inner.getBoundingClientRect().left;
      var linkLeft = link.getBoundingClientRect().left;
      var offset = Math.max(0, Math.round(linkLeft - innerLeft));
      dropdown.style.setProperty('--simple-dark-dropdown-offset', offset + 'px');
    }

    items.forEach(function (item) {
      // 悬停时（打开前）计算，保证首次展开就对齐
      item.addEventListener('mouseenter', function () {
        updateOffset(item);
      });
      // 键盘聚焦时同样处理
      item.addEventListener('focusin', function () {
        updateOffset(item);
      });
    });

    // 视口尺寸变化时，清掉旧值（下次 hover 重新计算）
    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var dropdown = item.querySelector(':scope > .navigation__tier-2-container');
        if (dropdown) dropdown.style.removeProperty('--simple-dark-dropdown-offset');
      });
    }, { passive: true });
  }

  /* ====== 滚动切换：顶部透明，滚过阈值后 is-scrolled（白底黑字） ======
     直接读取实际滚动位置，兼容 window、document.scrollingElement 和主题里的
     自定义滚动容器。避免 IntersectionObserver 哨兵在 sticky/display:contents
     组合下始终被判断为可见，导致 Header 无法恢复白底。 */
  function initScrollState(root) {
    var SCROLLED_CLASS = 'is-scrolled';
    var THRESHOLD = 8;
    var latestContainerScrollTop = 0;
    var ticking = false;

    /** @param {boolean} scrolled */
    function setScrolled(scrolled) {
      root.classList.toggle(SCROLLED_CLASS, !!scrolled);
    }

    function getDocumentScrollTop() {
      return Math.max(
        window.scrollY || 0,
        window.pageYOffset || 0,
        document.documentElement ? document.documentElement.scrollTop || 0 : 0,
        document.body ? document.body.scrollTop || 0 : 0,
        document.scrollingElement ? document.scrollingElement.scrollTop || 0 : 0
      );
    }

    function apply() {
      ticking = false;
      setScrolled(Math.max(getDocumentScrollTop(), latestContainerScrollTop) > THRESHOLD);
    }

    function onScroll(event) {
      var target = event && event.target;
      if (target && target !== document && target !== window && typeof target.scrollTop === 'number') {
        latestContainerScrollTop = target.scrollTop;
      } else {
        latestContainerScrollTop = getDocumentScrollTop();
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(apply);
    }

    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('pageshow', apply);
    window.addEventListener('resize', apply, { passive: true });
  }

  function boot() {
    document.querySelectorAll('firefly-mega-nav').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify 主题编辑器中 section 重载后重新初始化
  document.addEventListener('shopify:section:load', boot);
})();
